<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div
        v-if="userData"
        class="d-sm-flex d-none user-nav"
      >
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName || userData.username }}
        </p>
        <span class="user-status">{{ userData.role }}</span>
      </div>
      <b-avatar
        v-if="userData"
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.fullName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      :disabled="loggingOut"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ loggingOut ? logoutPending : $t('general.logout') }}</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import { getUserData } from '@/auth/utils'
import {
  BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'

import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
  },
  data() {
    return {
      loggingOut: false,
      userData: getUserData() || {},
      avatarText,
    }
  },
  computed: {
    logoutPending() {
      const labels = { fa: 'در حال خروج…', en: 'Signing out…', ar: 'جارٍ تسجيل الخروج…' }
      return labels[this.$i18n.locale] || labels.fa
    },
  },
  methods: {
    async logout() {
      if (this.loggingOut) return
      this.loggingOut = true
      try { await useJwt.logout({ revoke: true }) } finally { this.loggingOut = false }
    },
  },
}
</script>
